export const DEMO_PROFILES = [
  {
    id: "demo_landlord_avery",
    displayName: "Avery Chen",
    role: "Landlord",
    city: "Jersey City",
    state: "NJ",
    verified: true,
    trustScore: 92,
    bio: "Responsive housing provider focused on well-maintained small multifamily homes.",
    status: "Looking for tenant",
  },
  {
    id: "demo_manager_morgan",
    displayName: "Morgan Rivera",
    role: "Property Manager",
    city: "Newark",
    state: "NJ",
    verified: true,
    trustScore: 88,
    bio: "Manages resident communication and property maintenance requests.",
    status: "Active portfolio",
  },
];

export const DEMO_PROPERTIES = [
  {
    id: "demo_hamilton",
    title: "Hamilton Park Residences",
    address: "148 Mercer Street",
    city: "Jersey City",
    state: "NJ",
    monthlyRent: 2180,
    bedrooms: 2,
    bathrooms: 1,
    rating: 4.5,
    reviewCount: 14,
    forRent: true,
    landlordId: "demo_landlord_avery",
    risk: {
      level: "Low",
      score: 21,
      summary: "Recent sample reviews indicate responsive maintenance and generally quiet common areas.",
      categories: { Safety: 12, Maintenance: 20, Noise: 27, Responsiveness: 14 },
    },
    neighborhood: "Sample activity suggests walkable errands, variable street parking, and moderate weekend noise.",
  },
  {
    id: "demo_maple",
    title: "Maple Avenue Flats",
    address: "42 Maple Avenue",
    city: "Newton",
    state: "NJ",
    monthlyRent: 1650,
    bedrooms: 1,
    bathrooms: 1,
    rating: 3.8,
    reviewCount: 8,
    forRent: false,
    landlordId: "demo_manager_morgan",
    risk: {
      level: "Moderate",
      score: 46,
      summary: "Sample history includes recurring parking concerns and mixed maintenance response comments.",
      categories: { Safety: 19, Maintenance: 52, Noise: 33, Responsiveness: 48 },
    },
    neighborhood: "Sample reviews mention quieter evenings and limited off-street parking availability.",
  },
];

export const DEMO_REVIEWS = [
  {
    id: "demo_review_1",
    propertyId: "demo_hamilton",
    authorName: "Sample Tenant",
    rating: 5,
    text: "Maintenance responded quickly to a kitchen leak, and move-in communication was clear.",
    date: "May 2026",
  },
  {
    id: "demo_review_2",
    propertyId: "demo_maple",
    authorName: "Sample Resident",
    rating: 3,
    text: "The apartment was comfortable, but parking availability was difficult on some evenings.",
    date: "April 2026",
  },
];

export const DEMO_AI_MODULES = [
  {
    title: "AI Legal-Safe Review Assistant",
    text: "Rewrites emotionally worded drafts into factual, professional language without adding claims.",
    label: "Preview Only",
  },
  {
    title: "AI Scam Detector",
    text: "Flags pressure tactics, off-platform payments, and suspicious deposit requests.",
    label: "Preview Only",
  },
  {
    title: "AI Maintenance Analyzer",
    text: "Classifies reported repairs, highlights possible urgency, and prepares a clear maintenance summary.",
    label: "Preview Only",
  },
  {
    title: "AI Lease Explainer",
    text: "Turns lease language into plain-English guidance and calls out terms worth reviewing carefully.",
    label: "Preview Only",
  },
  {
    title: "AI Reputation Timeline",
    text: "Summarizes visible property and landlord review trends over time without treating claims as facts.",
    label: "Preview Only",
  },
  {
    title: "AI Smart Matching",
    text: "Suggests rental listings based on budget and preferences as more listing data becomes available.",
    label: "Coming Soon",
  },
  {
    title: "AI Move-In Assistant",
    text: "Builds checklists for photos, damage notes, utilities, keys, and walkthrough reminders.",
    label: "Preview Only",
  },
  {
    title: "AI Market Rent Estimator",
    text: "Compares available RentDuo rental listings when enough similar data exists.",
    label: "Coming Soon",
  },
];
